// Stuff like this is always more complex than it needs to be
// https://www.delftstack.com/howto/javascript/javascript-round-to-2-decimal-places
export default function roundCents(dollars: number): number {
  return +(Math.round(Number.parseFloat(dollars.toString() + 'e+2')) + 'e-2');
}
